import React, { useState } from "react";
import { useTable } from "react-table";

const Paginated = ({
  data,
  columns,
  onSearch,
  showTable = true,
  children,
  headerLeft,
}) => {
  const [searchText, setSearchText] = useState("");
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (!value) {
      onSearch("");
    }
  };

  const handleSearchClick = () => {
    onSearch(searchText.trim() ? searchText : "");
  };

  return (
    <div className="customTable">
      <div className="customTable__header">
        <div className="customTable__left">{headerLeft}</div>
        <div
          className="d-flex flex-column align-items-end gap-2"
          style={{ flex: 1, minWidth: 0 }}
        >
          <div className="d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search QR Code"
              value={searchText}
              onChange={handleSearch}
              onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
              style={{ width: "250px" }}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSearchClick}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {showTable ? (
        <div className="customTable__body">
          <div className="table-responsive">
            <table
              className="table table-striped table-bordered sticky_table"
              {...getTableProps()}
            >
              <thead>
                {headerGroups.map((headerGroup) => {
                  const { key, ...headerGroupProps } =
                    headerGroup.getHeaderGroupProps();
                  return (
                    <tr key={key} {...headerGroupProps}>
                      {headerGroup.headers.map((column) => {
                        const { key, ...headerProps } = column.getHeaderProps();
                        return (
                          <th key={key} {...headerProps}>
                            {column.render("Header")}
                          </th>
                        );
                      })}
                    </tr>
                  );
                })}
              </thead>
              {rows.length ? (
                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);
                    const { key, ...rowProps } = row.getRowProps();
                    return (
                      <tr key={key} {...rowProps}>
                        {row.cells.map((cell) => {
                          const { key, ...cellProps } = cell.getCellProps();
                          return (
                            <td key={key} {...cellProps}>
                              {cell.render("Cell") ? cell.render("Cell") : "Null"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{
                        textAlign: "center",
                        display: "table-cell",
                        textTransform: "Capitalize",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default Paginated;
